// export const BASE_URL = "https://gateway-clear-debt-credit.dsmeglobal.com/";
export const BASE_URL = "https://api-pecific-rim.dsmeglobal.com/";

export const Error_Codes = {
  success: 0,
  updated: 1,
  failed: 2,
  not_exist: 4,
};
